/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Docs_IntroInputs */

const en_docs_intro = /** @type {(inputs: Docs_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep turns an idea or an existing codebase into a PRD, features and a layered backlog, then hands tasks to your AI coding agent one at a time through the CLI.`)
};

const id_docs_intro = /** @type {(inputs: Docs_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep mengubah ide atau codebase yang sudah ada jadi PRD, fitur, dan backlog berlapis, lalu menyerahkan task ke AI coding agent kamu satu per satu lewat CLI.`)
};

/**
* | output |
* | --- |
* | "Bystep turns an idea or an existing codebase into a PRD, features and a layered backlog, then hands tasks to your AI coding agent one at a time through the CLI." |
*
* @param {Docs_IntroInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const docs_intro = /** @type {((inputs?: Docs_IntroInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Docs_IntroInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_docs_intro(inputs)
	return en_docs_intro(inputs)
});